import { Component, OnInit } from '@angular/core';
import { LicenseState } from '@/enums/licenseState';
import { Person } from '@/interfaces/person';
import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { Router, ActivatedRoute } from '@angular/router';
import { deofuscate, ofuscate } from '@/utils/obfuscation';
import { CommonService } from '@/services/common/common.service';
import { PersonService } from '@/services/person/person.service';
import { RequirementService } from '@/services/requirement/requirement.service';

@Component({
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css'],
})
export class SummaryComponent implements OnInit {

  requestType: 'personal' | 'third' = 'third';
  selectedPersonData?: Person;

  selectedLicense: Partial<CompleteLicense> = {};
  licenses: CompleteLicense[] = [];
  gettingLicenses: boolean = true;
  gettingLicensesError: string = 'DEFAULT_VALUE';
  zonesRows: Array<number[]> = [];
  sanctionType = '';
  shouldActiveButton: boolean[] = [];
  haveAnActiveRequirement: boolean[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private personService: PersonService,
    private requirementService: RequirementService,
  ) { }

  ngOnInit(): void {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);

      this.requestType = 'third';
      this.personService.getPersonDataById(params.personId).subscribe({
        next: (personData) => {
          this.selectedPersonData = personData;
          this.getLicenses(personData.mdmid);
        },
      });
    });
  }

  getLicenses(mdmid: string) {
    this.gettingLicenses = true;
    this.commonService.getLicensesDeletedByUser(mdmid)
      .subscribe({
        next: (res) => {
          this.licenses = res.sort((a, b) => {
            if (a.asset.name > b.asset.name) {
              return 1;
            }
            if (a.asset.name < b.asset.name) {
              return -1;
            }
            return 0;
          });

          this.licenses.map((license, index) => {
            this.getLicensesActiveRequirement(license.asset.id).subscribe({
              next: ({ exist }) => {
                this.haveAnActiveRequirement[index] = exist;
              },
            });
          });

          this.gettingLicenses = false;
          this.getZonesRows();
        },
        error: () => {
          this.gettingLicenses = false;
          this.gettingLicensesError = 'ERROR';
        },
      });
  }

  getZonesRows() {
    this.licenses.forEach((license) => {
      const zonesRowsByAsset: number[] = [];
      license.equipments.forEach((vehicle) => {
        const zonesLength = vehicle.conductionZones.length;
        zonesRowsByAsset.push(Math.ceil(zonesLength / 2));
      });
      this.zonesRows.push(zonesRowsByAsset);
    });
  }

  getLicensesActiveRequirement(assetId: number) {
    return this.requirementService
      .validateExistingExtendRequeriment({
        mdmid: this.selectedPersonData?.mdmid as string,
        assetId,
        requirementType: 2,
      });
  }

  onSelectLicense(licenseId: number) {
    const ofuscatedData = ofuscate({ id: licenseId });
    this.router.navigate(['detail', ofuscatedData], { relativeTo: this.route });
  }
}
